import numbro from 'numbro';

export const pseudoLocale: numbro.NumbroLanguage = {
  languageTag: 'ps-EU',
  delimiters: {
    thousands: '_',
    decimal: '~',
  },
  ordinal: (_number) => {
    return 'ord';
  },
  currency: {
    symbol: '§',
    position: 'prefix',
    code: 'PSE',
  },
  currencyFormat: {
    thousandSeparated: true,
    totalLength: 4,
    spaceSeparated: true,
    spaceSeparatedCurrency: true,
    average: true,
  },
  formats: {
    fourDigits: {
      totalLength: 4,
      spaceSeparated: true,
      average: true,
    },
    fullWithTwoDecimals: {
      output: 'currency',
      thousandSeparated: true,
      spaceSeparated: true,
      mantissa: 2,
    },
    fullWithTwoDecimalsNoCurrency: {
      mantissa: 2,
      thousandSeparated: true,
    },
    fullWithNoDecimals: {
      output: 'currency',
      thousandSeparated: true,
      spaceSeparated: true,
      mantissa: 0,
    },
  },
  abbreviations: {
    thousand: 'thou',
    million: 'mill',
    billion: 'bill',
    trillion: 'trill',
  },
};
